import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { mediaHelpers } from '../../../../global/viewSettings/importing/mediaResults';
import { _matchSeasonalCollection } from './SportsSeasonReducer';
import { ammendMatchesFromGsOrMedia } from './reducerHelpers/seasonSportsMatchData';
import { ammendRankingsFromGs } from './reducerHelpers/seasonSportsRankingsData';
import { seasonalUpdateTypes } from './reducerHelpers/seasonalDataHelpers';
import { sportsHelpers } from './reducerHelpers/sportsHelpers';
import { seasonalHelpers } from './reducerHelpers/seasonalHelpers';

export const matchStatusTypes = {
  allUpdates: 'allUpdates',
  cancelled: 'cancelled',
  dateChanged: 'dateChanged',
  duplicated: 'duplicated',
  duplicates: 'duplicates',
  exhibition: 'exhibition',
  existingDb: 'existingDb',
  inversed: 'inversed',
  locationChanged: 'locationChanged',
  matchNew: 'matchNew',
  nonDistrict: 'nonDistrict',
  notFound: 'notFound',
  playoff: 'playoff',
  postponed: 'postponed',
  resultsChanged: 'resultsChanged',
  resultsNew: 'resultsNew',
  sameTeams: 'sameTeams',
  season: 'season',
  seasonPlayoff: 'seasonPlayoff',
  tournamentMatchNew: 'tournamentMatchNew',
}

export const _matchLsTypes = {
  exhibition: 'exhibition',
  non: 'Non',
  Non: 'Non',
  nonSection: 'nonSection',
  nonLevel: 'nonLevel',
  nonDistrict: 'nonDistrict',
  playoffs: 'playoffs',
  tournament: 'tournament',
}

export const _mediaHeaders = {
  nonMatch: 'nonMatch',
  nonDistrict: 'nonDistrict',
  nonLevel: 'nonLevel',
  nonSection: 'nonSection',
  playoff: 'playoff',
  tournament: 'tournament',
  tbd: 'tbd',
}

export const sportsDataSearchTypes = {
  media_results: 'mediaResults',
  media_playoffResults: 'mediaPlayoffResults',
  googleSheets_results: 'googleSheetsResults',
  googleSheets_playoffResults: 'googleSheetsPlayoffResults',
}

const rts = {
  handleAmmend_gsMatches: 'handleAmmend_gsMatches',
  handleGet_gsMatches: 'handleGet_gsMatches',
  handleGet_gsMatchesTest: 'handleGet_gsMatchesTest',
  handleGet_gsRankings: 'handleGet_gsRankings',
  handleGet_gsRosters: 'handleGet_gsRosters',
  handleGet_matchesFlatData: 'handleGet_matchesFlatData',
  handleGet_mediaMatches: 'handleGet_mediaMatches',
  handleSet_currentFlatFiltered: 'handleSet_currentFlatFiltered',
  handleSet_gsResults: 'handleSet_gsResults',
  handleSet_gsRankings: 'handleSet_gsRankings',
  handleSet_gsRosters: 'handleSet_gsRosters',
  handleSet_matchDataUpdates: 'handleSet_matchDataUpdates',
  handleSet_matchPlayoffPendings: 'handleSet_matchPlayoffPendings',
  handleSet_mediaResults: 'handleSet_mediaResults',
  handleSet_schoolResults: 'handleSet_schoolResults',
  handleShow_matchEdit: 'handleShow_matchEdit',
  handleUpdate_gsMatchesSport: 'handleUpdate_gsMatchesSport',
  handleUpdate_gsRankings: 'handleUpdate_gsRankings',
  handleUpdate_matchesByLevel: 'handleUpdate_matchesByLevel',
  ...grts,
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsDataReducer = (state, action) => {

  const {
    _matchStatusGroups,
    _sportsYearAbr,
    database_fns,
    fn_cls,
    gameScoringType,
    latestSeason,
    links_score,
    mainDb,
    matches_flat,
    matches_info,
    matchResultsInfo,
    pathViews,
    sportPermissions,
    sportsKey,
    teams,
    useScoringCollection,
    useScoringCollectionOnly,
  } = state

  const { matchUpdates_data } = matchResultsInfo ?? {}

  const { values } = matches_flat ?? {}
  const { season: matches_flat_season, playoffs: matches_flat_playoff } = values ?? {}

  const { type, dispatch } = action

  const sportsData_handlers = sportsDataHandlers(dispatch)
  const { handleFunctionResponse, handleSet_gsResults, handleSet_gsRankings, handleSet_gsRosters, handleAmmend_gsMatches, handleSet_mediaResults, handleSet_schoolResults } = sportsData_handlers

  switch (type) {

    case rts.handleGet_matchesFlatData:
      return { ...state, matches_flat: getFlatMatches(matches_info, action) }

    case rts.handleGet_gsMatches:
      fn_cls.getGoogleSheetRange(action.gsValues ? action.gsValues : links_score, handleSet_gsResults, null, action?.gsValues?.ignoreStartCase, null, state.latestSeason, action.forPlayoffs, action.forMedia, action.usePure)
      return { ...state, forPlayoffs: action.forPlayoffs }

    case rts.handleGet_gsRankings:
      fn_cls.getGoogleSheetRange(action.gsValues ? action.gsValues : links_score, handleSet_gsRankings, null, null, null, state.latestSeason)
      return { ...state }

    case rts.handleGet_gsRosters:
      fn_cls.getGoogleSheetRange(action.gsValues ? action.gsValues : links_score, handleSet_gsRosters)
      return { ...state }

    case rts.handleSet_gsRosters:
      const { rosters_gs } = action
      return { ...state, updating: false, rosters_info: {} }

    case rts.handleSet_gsResults:
      ammendMatchesFromGsOrMedia(
        mainDb,
        action,
        matches_flat,
        matches_info,
        teams,
        gameScoringType,
        handleAmmend_gsMatches,
        pathViews
      )
      return { ...state, sportsDataSearchType: action.forPlayoffs ? sportsDataSearchTypes.googleSheets_playoffResults : sportsDataSearchTypes.googleSheets_results }

    case rts.handleSet_mediaResults:
      ammendMatchesFromGsOrMedia(mainDb, action, matches_flat, matches_info, teams, gameScoringType, handleAmmend_gsMatches)
      return { ...state }

    case rts.handleSet_gsRankings:
      const { rankings_gs } = action
      const _rankings = ammendRankingsFromGs(rankings_gs)
      return { ...state, updating: false, rankings_info: { rankings: _rankings } }

    case rts.handleGet_mediaMatches:
      mediaHelpers.getMedia_results(action.dateGroupKeys, action.forPlayoffs, state.links_score, action.year, action._sportsAbr, teams, action.forRefresh, handleSet_mediaResults)
      return { ...state, sportsDataSearchType: action.forPlayoffs ? sportsDataSearchTypes.media_playoffResults : sportsDataSearchTypes.media_results }

    case rts.handleAmmend_gsMatches:
      return {
        ...state,
        updating: false,
        gsMatchedRefreshed: true,
        forPlayoffs: action.forPlayoffs,
        matchResultsInfo: action.matchResultsInfo,
      }

    case rts.handleSet_schoolResults:
      return { ...state, schoolData: action.schoolData }

    case rts.handleGet_gsMatchesTest:
      // getGsTest('17wW4AqQOkVkHTAQ9ttl__AIQQhHadfVf4OppcAZSkLg', 'Results 2024')
      return { ...state }

    case rts.handleSet_matchDataUpdates:
      return { ...state, matchUpdates_data: action.matchDataUpdates }

    case rts.handleSet_matchPlayoffPendings:
      return { ...state, matchPlayoffPendings: action.matchPlayoffPendings }

    case rts.handleSet_currentFlatFiltered:
      const _matches_flat = { ...matches_flat }
      const { ft } = action
      let _updateCaption = 'Update Match Results'
      let updateAllowed;
      switch (ft) {
        case matchStatusTypes.allUpdates:
        case matchStatusTypes.cancelled:
        case matchStatusTypes.dateChanged:
        case matchStatusTypes.existingDb:
        case matchStatusTypes.inversed:
        case matchStatusTypes.matchNew:
        case matchStatusTypes.nonDistrict:
        case matchStatusTypes.postponed:
        case matchStatusTypes.resultsChanged:
        case matchStatusTypes.resultsNew:
        case matchStatusTypes.season:
        case matchStatusTypes.seasonPlayoff:
          updateAllowed = true
          break;
        default:
          // (1652
          updateAllowed = ft ? false : true
      }
      if (ft) {

        let _matchUpdates_data_selected;
        if (matchUpdates_data && ft && matchUpdates_data[ft]) {
          _matchUpdates_data_selected = matchUpdates_data[ft]
          matchResultsInfo._matchUpdates_data_selected = _matchUpdates_data_selected
        }
        const x = _matchStatusGroups ? _matchStatusGroups[ft] : []
        _matches_flat.counts.filtered = x ? Object.keys(x).length : 0
        _matches_flat.filtered.all = x
        return { ...state, matches_flat: _matches_flat, filterType: ft, updateCaption: _updateCaption, updateAllowed, matchResultsInfo }
      } else {
        if (state.forPlayoffs) {
          _matches_flat.counts.playoffs = matches_flat_playoff ? Object.keys(matches_flat_playoff).length : 0
          _matches_flat.filtered.playoffs = matches_flat_playoff
          return { ...state, matches_flat: _matches_flat, filterType: null, updateCaption: _updateCaption, updateAllowed }
        } else {
          _matches_flat.counts.season = matches_flat_season ? Object.keys(matches_flat_season).length : 0
          _matches_flat.filtered.season = matches_flat_season
          return { ...state, matches_flat: _matches_flat, filterType: null, updateCaption: _updateCaption, updateAllowed }
        }
      }

    case rts.handleUpdate_matchesByLevel:

      const { matchDayResults, latestSeason: latestSeason_a } = action

      const _latestSeason = latestSeason ? latestSeason : latestSeason_a

      const _cbms = () => {
        action.callback()
        const response_data = { success: true }
        handleFunctionResponse(response_data, dispatch)
      }

      const _updatePropsMd = {
        callback: _cbms,
        collectionName: _matchSeasonalCollection,
        forPlayoffs: action.forPlayoffs,
        pathViews,
        pks: seasonalHelpers.getPks(pathViews, _latestSeason, sportsKey),
        seasonalUpdateType: seasonalUpdateTypes.matchesList,
        useScoringCollection,
        useScoringCollectionOnly,
        sportPermissions,
        dataToUpdate: matchDayResults,
        database_fns
      }

      seasonalHelpers.updateSeasonalMatches_byLevel(_updatePropsMd)

      return state

    case rts.handleUpdate_gsMatchesSport:

      const { forPlayoffs, forRefresh, repairResults } = action

      const _cb = (res) => {
        const response_data = { success: true }
        handleFunctionResponse(response_data, dispatch)
      }

      const _updateProps = {
        callback: _cb,
        collectionName: _matchSeasonalCollection,
        forPlayoffs,
        forRefresh,
        matchDataUpdates: matchUpdates_data,
        repairResults,
        pathViews,
        pks: seasonalHelpers.getPks(pathViews, latestSeason, sportsKey),
        seasonalUpdateType: seasonalUpdateTypes.matchesList,
        useScoringCollection,
        useScoringCollectionOnly,
        sportPermissions,
        database_fns
      }

      if (matchUpdates_data) {
        seasonalHelpers.updateSeasonalMatches_allByLevel(_updateProps)
      }

      return { ...state }

    case rts.handleUpdate_gsRankings:
      const { rankings } = action.rankings_info ?? {}
      const _cbr = (res) => {
        const response_data = { success: true }
        handleFunctionResponse(response_data, dispatch)
      }
      if (rankings) {
        const data_rankings = {}
        Object.keys(rankings).forEach(selectedWeek => {
          const ranking = rankings[selectedWeek]
          Object.keys(ranking).forEach(selectedLevel => {
            data_rankings['rankings' + '.' + selectedWeek + '.' + selectedLevel] = ranking[selectedLevel];
          })
        })
        const _pkss = seasonalHelpers.getPks(pathViews, state.latestSeason, sportsKey, ['teams'])
        const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, _pkss, action.callback, 'rankings_seasonal', null, data_rankings, null, rankings, _sportsYearAbr)
        seasonalHelpers.update_seasonalOrGlobal(seasonalUpdateTypes.rankings, _updateProps)
        _cbr()
      }
      return { ...state }

    case rts.handleShow_matchEdit:
      return { ...state, showMatchProp: !state.showMatchProp, matchProp: action.matchProp, matchData_match: action.match }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStopUpdate:
    case rts.handleStartUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })

    default:
      return { ...state }
  }
}

export const sportsDataHandlers = (dispatch) => {
  return {
    handleAmmend_gsMatches: (matchResultsInfo, forPlayoffs) => { dispatch({ type: rts.handleAmmend_gsMatches, dispatch, matchResultsInfo, forPlayoffs }) },
    handleGet_gsMatches: (gsValues, forPlayoffs, forMedia, usePure) => { dispatch({ type: rts.handleGet_gsMatches, dispatch, gsValues, forPlayoffs, forMedia, usePure }) },
    handleGet_gsMatchesTest: (gsValues) => { dispatch({ type: rts.handleGet_gsMatchesTest, dispatch, gsValues }) },
    handleGet_gsRankings: (gsValues) => { dispatch({ type: rts.handleGet_gsRankings, dispatch, gsValues }) },
    handleGet_gsRosters: (gsValues) => { dispatch({ type: rts.handleGet_gsRosters, dispatch, gsValues }) },
    handleGet_matchesFlatData: (matchDate) => { dispatch({ type: rts.handleGet_matchesFlatData, dispatch, matchDate }) },
    handleGet_mediaMatches: (date, dateGroupKeys, forPlayoffs, year, forRefresh) => { dispatch({ type: rts.handleGet_mediaMatches, dispatch, date, dateGroupKeys, forPlayoffs, year, forRefresh }) },
    handleSet_currentFlatFiltered: (ft) => { dispatch({ type: rts.handleSet_currentFlatFiltered, dispatch, ft }) },
    handleSet_gsRankings: (gsValues, rankings_gs) => { dispatch({ type: rts.handleSet_gsRankings, dispatch, gsValues, rankings_gs }) },
    handleSet_gsResults: (gsValues, results_gs, team, forPlayoffs) => { dispatch({ type: rts.handleSet_gsResults, dispatch, gsValues, results_gs, team, forPlayoffs }) },
    handleSet_gsRosters: (gsValues, rosters_gs) => { dispatch({ type: rts.handleSet_gsRosters, dispatch, gsValues, rosters_gs }) },
    handleSet_matchDataUpdates: (matchDataUpdates) => { dispatch({ type: rts.handleSet_matchDataUpdates, dispatch, matchDataUpdates }) },
    handleSet_matchPlayoffPendings: (matchPlayoffPendings) => { dispatch({ type: rts.handleSet_matchPlayoffPendings, dispatch, matchPlayoffPendings }) },
    handleSet_mediaResults: (mediaMatches, forPlayoffs, year, sportsAbr, forRefresh) => { dispatch({ type: rts.handleSet_mediaResults, dispatch, mediaMatches, forPlayoffs, year, sportsAbr, forRefresh }) },
    handleSet_schoolResults: (schoolData) => { dispatch({ type: rts.handleSet_schoolResults, dispatch, schoolData }) },
    handleShow_matchEdit: (matchProp, match) => { dispatch({ type: rts.handleShow_matchEdit, dispatch, matchProp, match }) },
    handleUpdate_gsMatchesSport: (forPlayoffs, forRefresh, repairResults) => { dispatch({ type: rts.handleUpdate_gsMatchesSport, dispatch, forPlayoffs, forRefresh, repairResults }) },
    handleUpdate_gsRankings: (rankings_info) => { dispatch({ type: rts.handleUpdate_gsRankings, dispatch, rankings_info }) },
    handleUpdate_matchesByLevel: (matchDayResults, forPlayoffs, callback, latestSeason) => { dispatch({ type: rts.handleUpdate_matchesByLevel, dispatch, matchDayResults, forPlayoffs, latestSeason, callback }) },
    ...responseHandlers(dispatch),
  }
}

export const sportsDataInitialState = (init_state) => {
  return { ...init_state }
};

export const sendMatchMessage = async (matchStatus, _holeResult) => {
}

export const sendFcmMessage = async (currentUserId) => {
}

const getFlatMatches = (matches_info, action) => {

  const matches_flat = {
    actual: {
      season: sportsHelpers.getMatches_flat(matches_info.matches),
      playoffs: sportsHelpers.getMatches_flat(matches_info.matches_playoffs),
    },
    values: {
      season: null,
      playoffs: null,
    },
    filtered: {
      all: null,
      season: null,
      playoffs: null,
    },
    counts: {
      season: 0,
      playoffs: 0,
      filtered: 0,
    },
  }

  matches_flat.values.season = _.values(matches_flat.actual.season)
  matches_flat.values.playoffs = _.values(matches_flat.actual.playoffs)

  matches_flat.counts.season = matches_flat.values.season ? matches_flat.values.season.length : 0
  matches_flat.counts.playoffs = matches_flat.values.playoffs ? matches_flat.values.playoffs.length : 0

  return matches_flat
}
